import { RenderErrorBoundary } from '@components/RenderErrorBoundary'
import { RootContainer } from '@containers/root.container'
import { initSentry } from '@libs/sentry/sentry'
import { GoogleAnalyticsService } from '@utils/GoogleAnalyticsService'
import { reportReactError } from '@utils/reportReactError'
import React from 'react'
import { createRoot } from 'react-dom/client'

async function initApp() {
  initSentry()
  await GoogleAnalyticsService.init()

  createRoot(document.getElementById('root') as HTMLElement, {
    onUncaughtError: (error, info) => reportReactError('uncaught', error, info),
    onCaughtError: (error, info) => reportReactError('caught', error, info),
    onRecoverableError: (error, info) => reportReactError('recoverable', error, info),
  }).render(
    <React.StrictMode>
      <RenderErrorBoundary>
        <RootContainer />
      </RenderErrorBoundary>
    </React.StrictMode>,
  )
}

initApp()
